import React, { useState, useEffect } from "react";
import Tabs from "../chunks/Tabs";
import SettingRow from "../chunks/SettingRow";
import { useLocation } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert2";

const AdGooglePixelSetting = () => {
  const [measurementPara, setMeasurementPara] = useState(false);
  const [uetPara, setUetPara] = useState(false);
  const [stateData, setStateData] = useState(null);
  const [pixelsArr, setPixelArr] = useState(null);
  const [measurement, setMeasurement] = useState("");
  const [uetTagID, setUetTagID] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const shop_url = params.get("shop_url");
  const [id, setId] = useState("");
  const keyMap = {
    PURCHASE: "Purchase Tracking",
    ADD_TO_CART: "Add To Cart Tracking",
    BEGIN_CHECKOUT: "Begin Checkout Tracking",
    PAGE_VIEW: "Page View Tracking",
    dynamicRemarkiting: "Dynamic Remarketing",
    enhancedConversion: "Enhanced Conversions",
    includeTaxesAndShipping: "Include Taxes and Shipping",
  };
  const [conversations, setConversations] = useState({});

  const renameKeys = (obj, keyMap) => {
    return Object.entries(obj).reduce((newObj, [key, value]) => {
      const newKey = keyMap[key] || key; // Use new key if found, otherwise keep the same key
      newObj[newKey] = value;
      return newObj;
    }, {});
  };
  useEffect(() => {
    // Retrieve the row data from localStorage
    const storedData = localStorage.getItem("adPixelData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      console.log(parsedData);
      if (parsedData?.conversationActions) {
        const renamedConversationActions = renameKeys(
          JSON.parse(parsedData?.conversationActions),
          keyMap
        );
        setPixelArr(renamedConversationActions);
      }
      // setPixelArr(JSON.parse(parsedData?.conversationActions));
      setStateData(parsedData);
      setId(parsedData.id);
      setMeasurement(parsedData.measurementID);
      setUetTagID(parsedData.uetTagID);
    }
  }, []);

  console.log("ss", pixelsArr);
  const [accountArr, setAccountArr] = useState([
    {
      label: "Gmail",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: false,
    },
    {
      label: "Google Ads Customer ID",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: false,
    },
    {
      label: "GTM Container ID",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "GTM Account ID",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "Google Pixel ID",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "Purchase Label",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "Add to Cart Label",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "Begin Checkout Label",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
    {
      label: "Page View Label",
      value: "",
      placeholder: "example2gmail.com",
      type: "email",
      disabled: true,
    },
  ]);

  // const [pixelsArr, setPixelArr] = useState([
  //   {
  //     paraName: "Dynamic Remarking Pixel",
  //     active: true,
  //   },
  //   {
  //     paraName: "Dynamic Remarking Pixel",
  //     active: false,
  //   },
  //   {
  //     paraName: "Dynamic Remarking Pixel",
  //     active: true,
  //   },
  //   {
  //     paraName: "Dynamic Remarking Pixel",
  //     active: true,
  //   },
  // ]);

  const [actionsArr, setActionsArr] = useState([
    {
      label: "Dynamic Remarking Pixel",
      value: "Dynamic Remarking Pixel Dynamic Remarking Pixel",
      type: "text",
    },
    {
      label: "Dynamic Remarking Pixel",
      value: "Dynamic Remarking Pixel Dynamic Remarking Pixel",
      type: "text",
    },
    {
      label: "Dynamic Remarking Pixel",
      value: "Dynamic Remarking Pixel Dynamic Remarking Pixel",
      type: "text",
    },
  ]);

  useEffect(() => {
    if (stateData) {
      // Dynamically update the accountArr fields based on stateData
      setAccountArr((prevState) =>
        prevState.map((field) => {
          switch (field.label) {
            case "Gmail":
              return { ...field, value: stateData.email || "" };
            case "Google Ads Customer ID":
              return { ...field, value: stateData.googleAdsID || "" };
            case "GTM Container ID":
              return { ...field, value: stateData.gtmContainerID || "" };
            case "GTM Account ID":
              return {
                ...field,
                value: JSON.parse(stateData.gtmAccount).value || "",
              };
            case "Google Pixel ID":
              return { ...field, value: stateData.pixelId || "" };
            case "Purchase Label":
              return { ...field, value: stateData.purchaseLabel || "" };
            case "Add to Cart Label":
              return { ...field, value: stateData.addtocartLabel || "" };
            case "Begin Checkout Label":
              return { ...field, value: stateData.beginCheckoutLabel || "" };
            case "Page View Label":
              return { ...field, value: stateData.pageviewLabel || "" };
            default:
              return field;
          }
        })
      );
    }
  }, [stateData]);

  const handleInputChange = (index, value) => {
    setAccountArr((prevState) =>
      prevState.map((field, i) =>
        i === index ? { ...field, value: value } : field
      )
    );
  };

  const handleAccountValueChange = (index, value) => {
    const arr = [...accountArr];
    arr[index].value = value;
    setAccountArr(arr);
  };

  const handlePixelValueChane = (index) => {
    const arr = [...pixelsArr];
    arr[index].active = !arr[index].active;
    setPixelArr(arr);
  };

  const handleActionValueChange = (index, value) => {
    const arr = [...actionsArr];
    arr[index].value = value;
    setActionsArr(arr);
  };

  const handleMeasurement = () => {
    if (measurement !== "") {
      console.log(measurement, "measurement");
      const data = {
        measurementID: measurement,
      };
      try {
        const response = axios.put(
          `https://sgbnode.solcoder.com/google-adv/${id}`,
          data
        );

        if (response.status === 200) {
          swal({
            title: "Success!",
            text: "The measurement has been updated successfully.",
            icon: "success",
            buttons: false,
            timer: 2000, // Automatically close after 2 seconds
          }).then(() => {
            // Redirect after showing the success message
            const redirectUrl = `/google-adds-tracking?shop=${shop_url}`;
            window.location.href = redirectUrl;
          });
        }

        console.log("API response:", response.data);
      } catch (error) {
        console.error("Error completing pixel:", error);

        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          buttons: true,
        });
      }
      setMeasurementPara(true);
    }
  };

  const handleUET = () => {
    if (uetTagID !== "") {
      console.log(uetTagID, "uetTagID");
      const data = {
        uetTagID: uetTagID,
      };
      try {
        const response = axios.put(
          `https://sgbnode.solcoder.com/google-adv/${id}`,
          data
        );

        if (response.status === 200) {
          swal({
            title: "Success!",
            text: "The uetTagID has been updated successfully.",
            icon: "success",
            buttons: false,
            timer: 2000, // Automatically close after 2 seconds
          }).then(() => {
            // Redirect after showing the success message
            const redirectUrl = `/google-adds-tracking?shop=${shop_url}`;
            window.location.href = redirectUrl;
          });
        }

        console.log("API response:", response.data);
      } catch (error) {
        console.error("Error completing pixel:", error);

        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          buttons: true,
        });
      }
      setUetPara(true);
    }
  };

  const handleAccountSave = () => {
    const redirectUrl = `/google-pixel-edit?shop=${shop_url}`;
    window.location.href = redirectUrl;
  };

  const handlePixelSave = () => {
    pixelsArr?.map((val) => {
      return {
        pixel_titel: val?.paraName,
        pixel_active: val?.active,
      };
    });
  };

  const handleActionSave = () => {
    actionsArr?.map((val) => {
      return {
        action_titel: val?.label,
        action_value: val?.value,
      };
    });
  };

  return (
    <div className="pixel-screen-wrapper">
      <div className="main-container">
        <Tabs />
        <SettingRow
          heading="Settings"
          para="It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for 'lorem ipsum' will uncover many web
            sites still in their infancy. Various versions have evolved over the
            years, sometimes by accident, sometimes on purpose (injected humour
            and the like)"
          blueLink="to Container"
          youtubeLink="How To Add Google Pixel"
          youtubeLinkURL="#"
          backIcon={true}
          buttonName="Change Account"
          changeClick={handleAccountSave}
        >
          {accountArr?.map((val, ind) => {
            return (
              <>
                <label htmlFor={`input-${ind}`}>{val?.label}</label>
                <input
                  type={val?.type}
                  placeholder={val?.placeholder}
                  disabled={val?.disabled}
                  id={`input-${ind}`}
                  value={val?.value}
                  onChange={(e) => handleInputChange(ind, e.target.value)}
                />
              </>
            );
          })}
        </SettingRow>

        <SettingRow
          heading="Dynamic Remarking Pixel Conversion Status"
          youtubeLink="How To Add Google Pixel"
          youtubeLinkURL="#"
          backIcon={false}
          buttonName="Change Pixel"
          changeClick={handlePixelSave}
        >
          {Object.entries(pixelsArr || {}).map(([key, value], ind) => (
            <div key={key} className="row-container">
              <p>{key}</p>
              <button
                style={{
                  color: value ? "green" : "red",
                  backgroundColor: value ? "#7be394a9" : "#e37b7ba9",
                }}
                onClick={() => handlePixelValueChane(key)}
              >
                {value ? "Active" : "InActive"}
              </button>
            </div>
          ))}
        </SettingRow>

        <SettingRow
          heading="Selected Conversion Actions"
          backIcon={false}
          buttonName="Change"
          changeClick={handleActionSave}
        >
          {Object.entries(pixelsArr || {}).map(([key, value], ind) => (
            <div key={key} className="row-container">
              <p>{key}</p>
            </div>
          ))}
        </SettingRow>

        <SettingRow
          heading="Setup GA4"
          para="It is a long established fact"
          backIcon={false}
        >
          <label htmlFor="measurement">Measurement ID</label>
          <input
            type="text"
            id="measurement"
            style={{ backgroundColor: "white" }}
            onChange={(e) => setMeasurement(e.target.value)}
            value={measurement}
          />
          <button className="save-btn" onClick={handleMeasurement}>
            Save
          </button>
          {measurementPara && (
            <p className="time-para">
              It is a long established fact that a reader will be distracted.
            </p>
          )}
        </SettingRow>

        <SettingRow
          heading="UET Bing Conversion Tracking"
          para="It is a long established fact"
          backIcon={false}
        >
          <label htmlFor="uet-tag">UET Tag ID</label>
          <input
            type="text"
            id="uet-tag"
            style={{ backgroundColor: "white" }}
            onChange={(e) => setUetTagID(e.target.value)}
            value={uetTagID}
          />
          <button className="save-btn" onClick={handleUET}>
            Save
          </button>
          {uetPara && (
            <p className="time-para">
              It is a long established fact that a reader will be distracted.
            </p>
          )}
        </SettingRow>
      </div>
    </div>
  );
};

export default AdGooglePixelSetting;
